import Button from "components/common/controls/Button";
import SignInButton from "components/common/SignInButton";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import bannerImage from "static/images/landing-page/macbook-icon.svg";
import TryForFreeButton from "../../components/common/TryForFreeButton";
import IntegrationSupportBanner from "./IntegrationSupportBanner";

interface Props {
  onLearnMoreClick?: () => void;
}

export default function LandingPageBanner(props: Props) {
  const Buttons = () => {
    return (
      <div className="flex gap-x-4 flex-wrap justify-center gap-y-4">
        <div className="lg:hidden block">
          <SignInButton isPrimaryType />
        </div>
        <TryForFreeButton />
        <Button
          text="VIEW API DOCUMENTATION"
          onClick={props.onLearnMoreClick}
          radiusSize={ControlSize.Midium}
        />
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 xxl:grid-cols-2 w-full">
      <div>
        <h1 className="font-bold text-28px xxl:text-5xl xxl:text-left sm:text-center text-left leading-38px xxl:leading-76px mt-0 xxl:mt-20">
          Time‑Phased Project Data API for S‑Curves & BI Reporting
        </h1>
        <div className="text-base xxl:text-lg font-medium mt-6 xxl:text-left sm:text-center text-left leading-7 xxl:leading-37px">
          <p>Generate time‑phased values from Primavera, MS Project or Excel — instantly via API.</p>
        </div>
        <div className="hidden md:flex mt-8 xxl:justify-start justify-center">
          <Buttons />
        </div>
        <div className="mt-13 md:mt-13 text-center sm:text-left hidden xxl:block">
          <IntegrationSupportBanner />
        </div>
      </div>
      <div className="mt-5 md:mt-10 xxl:mt-0 flex justify-center">
        <img src={bannerImage} alt="banner" />
      </div>
      <div className="md:hidden mt-8 flex justify-center">
        <Buttons />
      </div>
      <div className="mt-13 md:mt-13 text-center xxl:hidden">
        <IntegrationSupportBanner />
      </div>
    </div>
  );
}
